import React, { useEffect, useState } from 'react'

import { Box } from '@mui/material'

interface TimerProps {
  expiredAt: string
  timeIsOut?: () => void | undefined
}

export const CountdownTimer = ({ expiredAt, timeIsOut }: TimerProps) => {
  const [timeRemaining, setTimeRemaining] = useState('')

  useEffect(() => {
    const expirationTime = new Date(expiredAt).getTime()

    const timerInterval = setInterval(() => {
      const currentTime = new Date().getTime()
      const remaining = expirationTime - currentTime

      if (remaining <= 0) {
        clearInterval(timerInterval)
        if (timeIsOut) {
          timeIsOut()
        }
      } else {
        const minutes = Math.floor(remaining / 1000 / 60)
        const seconds = Math.floor((remaining / 1000) % 60)
        const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
        setTimeRemaining(formattedTime)
      }
    }, 1000)

    return () => clearInterval(timerInterval)
  }, [expiredAt])

  return (
    <span style={{ display: 'inline-block', width: '44px', padding: '0 4px' }}>
      {timeRemaining ? `${timeRemaining}` : '--:--'}
    </span>
  )
}
